<template>
  <div class="dashboard_right absolute">
    <div class="right_contain">
      <div class="children">
        <HighVibration></HighVibration>
      </div>
    </div>
  </div>
</template>

<script>
import HighVibration from "./component/HighVibration.vue";
export default {
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {},
  components: {
    HighVibration
  }
};
</script>

<style scoped lang="scss">
@import url("../../../../assets/scss/common.scss");

.dashboard_right {
  width: 400px;
  height: 100%;
  top: -10px;
  right: 0;
  display: flex;
  flex-flow: column;
  .right_contain {
    flex: 1;
    .children {
      width: 100%;
      height: 100%;
      padding: 20px 20px 10px;
      box-sizing: border-box;
      background-color: rgba(0, 0, 0, 0.5);
      border-radius: 10px;
      margin-bottom: 10px;
      &:nth-of-type(2n) {
        margin-bottom: 0px;
      }
      &.status {
        height: auto;
        min-height: 30%;
      }
    }
  }
}
</style>
